/**
 * The responsibility of this file is to render a infinity loader animation.
 * It is used in manage ticket card to show that ticket sold quantity is exceeding the limit.
 */

import React from 'react';
import '../styles/animation/InfinityLoader.css';

function InfinityLoader() {
    return (
        // <svg
        //     width="70px"
        //     height="auto"
        //     viewBox="0 12 187.3 93.7"
        // >
        //     <path
        //         stroke="#fff"
        //         id="outline"
        //         fill="none"
        //         strokeWidth="10"
        //         strokeLinecap="round"
        //         strokeLinejoin="round"
        //         strokeMiterlimit="10"
        //         d="M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 				c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
        //     />
        //     <path
        //         id="outline-bg"
        //         opacity="0.35"
        //         fill="none"
        //         stroke="#26c1e8"
        //         strokeWidth="10"
        //         strokeLinecap="round"
        //         strokeLinejoin="round"
        //         strokeMiterlimit="10"
        //         d="M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 				c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
        //     />
        // </svg>
        <svg
            width="70px"
            height="auto"
            viewBox="0 12 187.3 93.7"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <linearGradient id="col">
                    <stop offset="0%" stopColor="#26c1e8" />
                    <stop offset="100%" stopColor="#f5f5f5" />
                </linearGradient>
            </defs>
            <path
                id="outline"
                d="M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
            />
            <path
                id="outline-bg"
                d="M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
            />
        </svg>
    );
}

export default InfinityLoader;
